import { css as _css } from "@emotion/core";
import React from 'react';
import PropTypes from 'prop-types';
import ButtonContent from './ButtonContent/ButtonContent';
import style from './Button.style';
import ButtonBase from '../ButtonBase/ButtonBase';
import { jsx as ___EmotionJSX } from "@emotion/core";
const types = ['primary', 'secondary', 'text'];
const Button = React.forwardRef(({
  children,
  type,
  size,
  iconLeft,
  iconRight,
  loading,
  disabled,
  className,
  onClick,
  onBlur,
  onFocus,
  onMouseLeave,
  onMouseOver,
  onTouchEnd,
  onTouchStart,
  id,
  href,
  'data-testid': dataTestId,
  'aria-label': dataLabel,
  'aria-describedby': ariaDescribedBy
}, ref) => ___EmotionJSX(ButtonBase, {
  css: /*#__PURE__*/_css([style.container.bySize[size]], ";label:Button;" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */")),
  context: "button",
  disabled: disabled,
  className: className,
  onClick: onClick,
  onBlur: onBlur,
  onFocus: onFocus,
  onMouseLeave: onMouseLeave,
  onMouseOver: onMouseOver,
  onTouchEnd: onTouchEnd,
  onTouchStart: onTouchStart,
  type: types.includes(type) ? type : 'secondary',
  id: id,
  href: href,
  "data-testid": dataTestId,
  "aria-label": dataLabel,
  "aria-describedby": ariaDescribedBy,
  ref: ref
}, ___EmotionJSX(ButtonContent, {
  loading: loading,
  IconLeft: iconLeft,
  IconRight: iconRight,
  size: size
}, children)));
Button.defaultProps = {
  type: 'secondary',
  size: 'medium',
  loading: false,
  disabled: false,
  iconLeft: undefined,
  iconRight: undefined,
  className: undefined,
  onClick: undefined,
  onBlur: () => {},
  onFocus: () => {},
  onMouseLeave: () => {},
  onMouseOver: () => {},
  onTouchEnd: () => {},
  onTouchStart: () => {},
  id: null,
  href: null,
  'data-testid': '',
  'aria-label': '',
  'aria-describedby': undefined
};
Button.propTypes = {
  /** The main style of the button */
  type: PropTypes.oneOf(types),

  /** The button size */
  size: PropTypes.oneOf(['xsmall', 'small', 'medium']),

  /** Is the loading component displayed */
  loading: PropTypes.bool,

  /** Is the button disabled */
  disabled: PropTypes.bool,

  /** The icon to be displayed on the left side */
  iconLeft: PropTypes.elementType,

  /** The icon to be displayed on the right side */
  iconRight: PropTypes.elementType,

  /** The content of the button */
  children: PropTypes.node.isRequired,

  /** Custom class name to include own styles */
  className: PropTypes.string,

  /** Callback to be called on click */
  onClick: PropTypes.func,

  /** On blur callback */
  onBlur: PropTypes.func,

  /** On focus callback */
  onFocus: PropTypes.func,

  /** On mouse leave callback */
  onMouseLeave: PropTypes.func,

  /** On mouse over callback */
  onMouseOver: PropTypes.func,

  /** On touch end callback */
  onTouchEnd: PropTypes.func,

  /** On touch start callback */
  onTouchStart: PropTypes.func,

  /** Unique ID */
  id: PropTypes.string,

  /** URL for anchor button */
  href: PropTypes.string,
  'data-testid': PropTypes.string,
  'aria-label': PropTypes.string,

  /** Button aria-describedby */
  'aria-describedby': PropTypes.string
};
Button.displayName = 'Button';
export default React.memo(Button);
//# sourceMappingURL=Button.js.map